import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, ShieldCheck } from "lucide-react";

export default function RecruiterRegisterPage() {
  const { registerRecruiter } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await registerRecruiter(email, password, name, companyName);
    setLoading(false);
    if (result.success) {
      navigate("/recruiter/dashboard");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="recruiter-register-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-6 justify-center">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-400 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-white" />
            </div>
          </Link>
          <h1 className="font-heading text-2xl font-semibold text-white">Verified Recruiter Access</h1>
          <p className="text-sm text-slate-400 mt-2">Search and hire skilled Salesforce Data Cloud talent. Accounts are admin-reviewed before activation.</p>
        </div>

        <div className="glass-panel rounded-2xl p-8">
          {error && (
            <div data-testid="recruiter-register-error-message" className="mb-4 text-sm bg-red-500/10 border border-red-500/30 text-red-300 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Your Name</label>
              <input
                type="text" required value={name} onChange={(e) => setName(e.target.value)}
                data-testid="recruiter-register-name-input"
                className="mt-1.5 w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
                placeholder="Jane Recruiter"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Company Name</label>
              <input
                type="text" required value={companyName} onChange={(e) => setCompanyName(e.target.value)}
                data-testid="recruiter-register-company-input"
                className="mt-1.5 w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
                placeholder="Acme Corp"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Work Email</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="recruiter-register-email-input"
                className="mt-1.5 w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
                placeholder="you@company.com"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Password</label>
              <input
                type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="recruiter-register-password-input"
                className="mt-1.5 w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit" disabled={loading} data-testid="recruiter-register-submit-button"
              className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-indigo-500 hover:opacity-90 text-white font-semibold py-2.5 rounded-lg transition-opacity disabled:opacity-60"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Request Recruiter Access
            </button>
          </form>

          <p className="text-center text-sm text-slate-400 mt-6">
            Are you a learner?{" "}
            <Link to="/register" data-testid="go-to-learner-register-link" className="text-indigo-400 hover:text-indigo-300 font-medium">Sign up here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
